import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import EstateService from '/@/modules/estate/services/EstateService';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';

export class LiquidationLetterExportService extends ExportTypeBaseService {
  /**
   * @var {Estate}
   */
  estate;

  /**
   * @return {string}
   */
  getFilename() {
    this.estate = getters.export.getData().estate;
    return `${this.estate.contact.fullName.replaceAll(' ', '-')}-liquidation-letter.pdf`;
  }

  /**
   * @return {*}
   */
  getSnackBarTitle() {
    this.estate = getters.export.getData().estate;
    return Lang.t("asset.letter-now-exporting", {
      name: this.estate.contact.fullName
    });
  }
}

export default new LiquidationLetterExportService();
